import { MimeTypeDefault, MimeTypes } from '@app/constants';

export const getMimeTypeFromPath = (filepath: string, defaultType = MimeTypeDefault): string => {
	const ext = filepath.split('.').pop();
	return MimeTypes[`.${ext}`] ?? defaultType;
};
